import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initSentry } from "./lib/sentry";

// Initialize Sentry error tracking
initSentry();

// Hide SEO fallback content when React mounts
const seoContent = document.getElementById("seo-content");
if (seoContent) {
  seoContent.style.display = "none";
}

createRoot(document.getElementById("root")!).render(<App />);
